import { Box, InputBase, List, useTheme,ToggleButton, ToggleButtonGroup, IconButton } from "@mui/material"
import { useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Shbutton from "../../theme/buttons/Shbutton";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useGetEnumsQuery } from "../../../newapi/global/generalApiSlice";
import { showToastMessage, showToastMessagePostRequest, showToastMessageRequestError } from "../../../utils/toasts";
import ShSwitch from "../../theme/inputs/ShSwitch";
import * as yup from "yup";
import ShValidatedInput from "../../theme/inputs/ShValidatedInput";
import ShValidatedInputDropdown from "../../theme/dropdowns/ShValidatedInputDropdown";
import { yupRequired } from "../../../utils/validation";
import { useAddOrderFieldsMutation } from "../../../newapi/order/orderFieldSlice";
import cx from "classnames";

const MAddOrderField = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [selected, setSelected] = useState(-1);
    const [addOrderFields,{isLoading}] = useAddOrderFieldsMutation();

    const select = (selected) => {
        setSelected(selected);
    }

    const [productFieldInfo, setOrderFieldsInfo] = useState({
        name: "",
        valueType: "",
        hideForManualCreation: false,
        listValues: []
    });
      
    const handleClose = () => {
      setOrderFieldsInfo({
          name: "",
          valueType: "",
          hideForManualCreation: false,
          listValues: []
      });
      props.handleClose();
  }

    const { data: globalEnums, enumIsLoading } = useGetEnumsQuery("orderfield_value_type");

    const [fieldErrors, setFieldErrors] = useState({});

    const rules = {
        name: yupRequired('name', t),
        valueType: yupRequired('value_type', t)
    };
    
    const schema = yup.object().shape(rules);
      
   
    const SaveOrderFields = async (productFieldInfo, props) => {
        try {
            if (isLoading) return;

            if (productFieldInfo.valueType === "list" && productFieldInfo.listValues.some(x => !x || x.length === 0)) {
                showToastMessage("error", t("option_cannot_be_empty"));
                return;
            }

            setFieldErrors({});
            await schema.validate(productFieldInfo, { abortEarly: false });
            const data = await addOrderFields(productFieldInfo).unwrap()
            showToastMessagePostRequest(t, data);

            handleClose();
        } catch (err) {
            if (err.name === 'ValidationError') {
                // Create an errors object where keys are field names and values are error messages
                const errors = err.inner.reduce((acc, currentError) => ({
                  ...acc,
                  [currentError.path]: currentError.message
                }), {});

                // Set the validation errors in the state
                setFieldErrors(errors);
              } else {
                // Handle other errors, such as network errors
                showToastMessageRequestError(t("create_failed"), t, err);
              }
        }
    };

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleChange = (key, value) => {
        const updates = {
          ...productFieldInfo,
          [key]: value
        };

        // If valueType is changed and it's "list", initialize with 2 empty values
        if (key === "valueType") {
            if (value === "list") {
                updates.listValues = ["", ""];
            } else {
                updates.listValues = [];
            }
        }

        setOrderFieldsInfo(updates);
        setFieldErrors({
            ...fieldErrors,
            [key]: ''
          });
      };

    const handleToggleButtonChange = (event, field) => {
        setOrderFieldsInfo({
            ...productFieldInfo,
            [field]: event.target.value === "true"
        });
    };

    const handleListValueChange = (index, value) => {
        setOrderFieldsInfo(prevInfo => ({
            ...prevInfo,
            listValues: prevInfo.listValues.map((item, i) => i === index ? value : item)
        }));
    };

    const handleDeleteListValue = (index) => {
        setOrderFieldsInfo(prevInfo => ({
            ...prevInfo,
            listValues: prevInfo.listValues.filter((_, i) => i !== index)
        }));
    };

    const handleNewListValueRow = () => {
        setOrderFieldsInfo(prevInfo => ({
            ...prevInfo,
            listValues: [...prevInfo.listValues, ""]
        }));
    };

    return(
        <SHModal
            open={props.open}
            onClose={handleClose}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}>
                <Subheading>{t("add_field")}</Subheading>
                {/* <Text light>The data presented will automatically be filtered through the selected warehouses</Text> */}
            </Box>

            {/* BODY */}
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding:3,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    flexDirection:"column",
                    gap:2
                }}
            >
                

                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("name")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                        <ShValidatedInput
                            name="name"
                            value={productFieldInfo.name}
                            onChange={handleChange}
                            error={fieldErrors.name}
                        />
                    </Box>
                </Box>
                <Box 
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >

                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("value_type")}</Text>
                    </Box>
                    
                    <Box
                        sx={{
                            flex:1,
                            backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                            borderRadius:4,
                            display:"flex",
                            height:32
                        }}
                    >
                    <ShValidatedInputDropdown
                      name="valueType"
                      displayName="displayName"
                      changeField={"name"}
                      selected={globalEnums ? globalEnums["orderfield.value.type"].findIndex(item => item === productFieldInfo.valueType) ?? -1 : -1}
                      options={globalEnums ? globalEnums["orderfield.value.type"].map((item, index) => ({ id: index, name: item, displayName: t(item) })) : []}
                      noSelection={t("choose_option")} 
                      onChange={handleChange}
                      error={fieldErrors.valueType}
                  />
                    </Box>
                </Box>
                <Box
                    sx={{
                        width:1,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box
                        sx={{
                            width:120,
                        }}
                    >
                        <Text light>{t("hide_for_manual_orders")}</Text>
                    </Box>

                    <Box
                        sx={{
                            flex:1,
                            display:"flex",
                        }}
                    >
                        <ToggleButtonGroup
                            color={productFieldInfo?.hideForManualCreation === true ? "green" : "red"}
                            value={productFieldInfo?.hideForManualCreation === true ? "true" : "false"}
                            exclusive
                            onChange={(e) => handleToggleButtonChange(e, "hideForManualCreation")}
                            aria-label="Hide for manual creation"
                            className={cx(`${productFieldInfo?.hideForManualCreation}`, {
                                'active': productFieldInfo?.hideForManualCreation === true
                            })}
                            sx={{
                                background: colors.red[100],
                                padding:0.5,
                                borderRadius:5,
                                transition:"250ms",
                                "&.active" : {
                                    background:colors.green[100],
                                    transition:"250ms",
                                },
                            }}
                        >
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.green[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.red[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="false">
                                {t('no')}
                            </ToggleButton>
                            <ToggleButton
                                sx={{
                                    padding:0,
                                    paddingX:2,
                                    border:0,
                                    lineHeight:"32px",
                                    textTransform:"unset",
                                    borderRadius:"32px !important",
                                    color:colors.red[400],
                                    transition:"250ms",
                                    "&.Mui-selected,&.Mui-selected:hover" : {
                                        background:colors.green[400],
                                        color:`${theme.palette.mode === "dark" ? "rgba(0,0,0,.75)" : "#fff"}`
                                    }
                                }}
                                value="true"
                            >
                                {t('yes')}
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Box>
                </Box>

                {productFieldInfo?.valueType === "list" && (
                    <>
                    <Text bold>{t("options")}</Text>
                        {productFieldInfo?.listValues?.map((listValue, index) => (
                        <Box
                            key={"sh-of-listvalue-"+index}
                            sx={{
                                width:1,
                                display:"flex",
                                alignItems:"center",
                                justifyContent:"space-between",
                                gap:7
                            }}
                        >
                            <Box
                                sx={{
                                    width:120,
                                }}
                            >
                                <Text light>{t('value')}</Text>
                            </Box>
                            <Box
                                sx={{
                                    flex:1,
                                    backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                                    borderRadius:4,
                                    display:"flex",
                                    height:32
                                }}
                            >
                                <InputBase
                                    type="text"
                                    sx={{
                                        px:2,
                                        flex:1,
                                        color:colors.txt["primary"],
                                        lineHeight:`32px`,
                                    }}
                                    value={listValue}
                                    onChange={(e) => handleListValueChange(index, e.target.value)}
                                />
                                {index > 1 && (
                                <IconButton type="button" onClick={() => handleDeleteListValue(index)}
                                sx={{
                                    color: colors.txt["primary"]
                                }}>
                                    <DeleteIcon/>
                                </IconButton>
                                )}
                            </Box>
                        </Box>
                        ))}
                        <Box sx={{marginLeft: 1}}>
                            <ButtonGroup version={2} >
                                <Shbutton className={"group-btn"} color={"green"}
                                variant="contained"
                                startIcon={<AddIcon/>}
                                onClick={() => handleNewListValueRow()}
                                >{t("add_list_value")}</Shbutton>
                            </ButtonGroup>
                        </Box>
                    </>
                )}
            </Box>
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    // paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton isCancel={true} className={"always-visible"} onClick={handleClose} color="primary" variant="text" startIcon={<ArrowRightAltIcon/>}>{t("cancel")}</Shbutton>
                <ButtonGroup version={2}> 
                    <Shbutton isLoading={isLoading} className={"group-btn"} color={"green"}
                    variant="contained" 
                    onClick={() => SaveOrderFields(productFieldInfo, props)}
                    >{t("add")}</Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MAddOrderField;
